// extracted by mini-css-extract-plugin
module.exports = {"tabsList":"LinkTabs_tabsList__mXcXu","tabsTrigger":"LinkTabs_tabsTrigger__ZU5C4","tabsSelect":"LinkTabs_tabsSelect__aTzPI"};